import { debug, isEmpty } from './utils.js';
import { PCI_PROJECT_MODE_VALUES } from './constants.js';
export class OvhAtInternetConfig {
    constructor() {
        this.enabled = true;
        this.region = '';
    }
    isDefaultSet() {
        return !isEmpty(this.defaults);
    }
    setDefaults(def) {
        this.defaults = def;
        debug('tracking set defaults', def);
        return this.defaults;
    }
    getDefaults() {
        return Object.assign({}, this.defaults);
    }
    setRegion(region) {
        this.region = region;
    }
    isEnabled() {
        return this.enabled;
    }
    setEnabled(state) {
        this.enabled = state;
        debug(`tracking ${state ? 'enabled' : 'disable'}`);
    }
    setPciProjectMode(params) {
        if (params === null || params === void 0 ? void 0 : params.isDiscoveryProject) {
            this.defaults.pciProjectMode = PCI_PROJECT_MODE_VALUES.DISCOVERY;
        }
        else if (params === null || params === void 0 ? void 0 : params.projectId) {
            this.defaults.pciProjectMode = PCI_PROJECT_MODE_VALUES.FULL;
        }
        else {
            this.defaults.pciProjectMode = PCI_PROJECT_MODE_VALUES.NONE;
        }
    }
}
export default { OvhAtInternetConfig };
//# sourceMappingURL=config.js.map